// פונקציית עזר לבניית צורת הציווי בבניין 1 בגזרת השלמים

/**
 * בונה צורות ציווי מתוך שורש ונתוני פועל
 * @param {string} root - השורש (3 אותיות ערביות)
 * @param {string} faVowelFuture - התנועה של האות השנייה בעתיד (a, i, u)
 * @returns {Object} אובייקט עם צורות הציווי לכל הגופים
 */
export function buildImperativeFormI_Salim(root, faVowelFuture) {
  if (!root || root.length < 3 || !faVowelFuture) {
    return null;
  }

  // הסרת רווחים מהשורש
  const cleanRoot = root.trim().replace(/\s+/g, '');
  
  // בדיקה שיש לפחות 3 אותיות
  if (cleanRoot.length < 3) {
    return null;
  }

  // חילוץ אותיות השורש (תומך גם בשורשים עם ניקוד)
  const rootLetters = extractRootLetters(cleanRoot);
  
  if (rootLetters.length < 3) {
    return null;
  }

  const R1 = rootLetters[0]; // אות ראשונה
  const R2 = rootLetters[1]; // אות שנייה
  const R3 = rootLetters[2]; // אות שלישית

  const kasra = '\u0650'; // ِ

  // קביעת האות הראשונה לפי fa_vowel_future
  const firstLetter = faVowelFuture.toLowerCase() === 'u' ? 'ا\u064F' : `ا${kasra}`;

  // קביעת הניקוד של האות השנייה
  const vowelMap = {
    'u': '\u064F', // damma ُ
    'a': '\u064E', // fatha َ
    'i': '\u0650'  // kasra ِ
  };
  
  const R2_vowel = vowelMap[faVowelFuture.toLowerCase()] || '\u064E';
  
  // סוכון
  const sukun = '\u0652'; // ْ
  const damma = '\u064F'; // ُ

  const shadda = '\u0651';
  const fatha = '\u064E';
  const isNunEnding = R3 === 'ن';

  // בניית צורות הציווי
  const imperative = {
    // אתה - sukun על האות השלישית
    'you_ms': `${firstLetter}${R1}${sukun}${R2}${R2_vowel}${R3}${sukun}`,
    
    // את - kasra + ي
    'you_fs': `${firstLetter}${R1}${sukun}${R2}${R2_vowel}${R3}${kasra}ي`,
    
    // אתם - damma + وا
    'you_mp': `${firstLetter}${R1}${sukun}${R2}${R2_vowel}${R3}${damma}وا`,
    
    // אתן - אידג'ם כאשר R3 היא ن
    'you_fp': isNunEnding
      ? `${firstLetter}${R1}${sukun}${R2}${R2_vowel}${R3}${shadda}${fatha}`
      : `${firstLetter}${R1}${sukun}${R2}${R2_vowel}${R3}${sukun}نَ`
  };

  return imperative;
}

/**
 * מחלץ את אותיות השורש מתוך מחרוזת (מתעלם מניקוד)
 * @param {string} text - טקסט ערבי
 * @returns {Array} מערך של אותיות בסיס
 */
function extractRootLetters(text) {
  // ניקוד ותווים מיוחדים שצריך להסיר
  const diacritics = /[\u064B-\u065F\u0670]/g;
  
  // הסרת ניקוד
  const cleaned = text.replace(diacritics, '');
  
  // החזרת מערך של אותיות
  return cleaned.split('').filter(char => char.trim() !== '');
}

/**
 * בונה צורות ציווי מתוך שורה של CSV
 * @param {Object} verbRow - שורה מקובץ ה-CSV
 * @returns {Object} אובייקט עם צורות הציווי
 */
export function buildImperativeFromRow(verbRow) {
  const root = verbRow['שורש'] || verbRow['root'];
  const faVowelFuture = verbRow['R2_FUTURE'] || verbRow['fa_vowel_future'];
  
  return buildImperativeFormI_Salim(root, faVowelFuture);
}
